import type { HubspotFormProps } from './types'

export default function HubspotForm({
	heading,
	region,
	portalId,
	formId,
	containerId,
	isPart = false,
	styled = true,
}: HubspotFormProps) {
	// Empty container: HubSpot's embed script fills it in the browser — and it
	// fills it with an `<iframe>` holding its own document, not with markup in
	// ours, so the form's own styling cannot come from this class. It comes
	// from public/hubspot-form.css, injected into that iframe by whichever init
	// script owns the page (see the `styled` prop). `hubspot-form` remains
	// useful as the wrapper hook for anything *around* the iframe.
	const content = (
		<div className="hubspot-form @container">
			{heading && <h2 className="h2 text-black-950 mb-6">{heading}</h2>}
			<div
				id={containerId || undefined}
				data-hubspot-form
				data-hubspot-region={region}
				data-hubspot-portal-id={portalId}
				data-hubspot-form-id={formId}
				data-hubspot-styled={styled ? 'true' : undefined}
			/>
		</div>
	)

	if (isPart) {
		return (
			<div className="container my-16">
				<div className="max-w-175 ml-auto">{content}</div>
			</div>
		)
	}

	return <div className="my-12">{content}</div>
}
